export default {
  subtotal: 'Zwischensumme',
  tip: 'Trinkgeld',
  discount: 'Rabatt',
  method_fee: 'Liefergebühr',
  service_fee: 'Onlinezuschlag',
  payment_method_upcharge_fee: {
    title: 'PayPal Gebühr',
    description:
      'Jedes Mal, wenn ein Kunde mit PayPal zahlt, nimmt PayPal 6-7% Gebühren. Also verlieren wir bei 100€ schon 6-7€. Daher müssen wir leider einen Aufschlag von 3,5% für die Nutzung von PayPal erheben. 🤯 Bitte erwäge, eine der anderen sicheren und verschlüsselten Zahlungsmethoden beim Bezahlen zu nutzen. Wir sind sehr dankbar für dein Verständnis und deine Unterstützung! 🙏',
  },
  tax: 'Taxes',
  total: 'Gesamt',
  earned_points: 'Du hast {{points}} Punkte verdient.',
};
